import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {CollapseBlock} from '../../../../common/index.jsx';
import {useTranslation} from 'react-i18next';
import Form from '../../../../antd/form/Form/Form.jsx';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField.jsx';
import FormSelect from '../../../../antd/form/FormSelect/FormSelect.jsx';
import {required} from '../../../../antd/form/FormValidation.js';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import FormSwitch from '../../../../antd/form/FormSwitch/FormSwitch.jsx';

const StudyProgramForm = ({
                             form,
                             studyProgramTypes,
                             teachers,
                             onSubmit,
                             initials,
                             isCreate,
                           }) => {
  const {t} = useTranslation();

  const studyProgramTypesOptions = useMemo(() => {
    if (!studyProgramTypes) return [];
    return studyProgramTypes.map(item => ({
      value: item.id,
      label: item.name,
    }));
  }, [studyProgramTypes]);

  const teachersOptions = useMemo(() => {
    if (!teachers) return [];
    return teachers.map(person => ({
      value: person.person_id,
      label: person.fullName,
    }));
  }, [teachers]);

  return (
    <Form
      form={form}
      initialValues={initials}
      onFinish={onSubmit}
    >
      <CollapseBlock
        collapsible
        collapse
        title={t('Informácie o študijnom programe')}
      >
        <FormTextField
          label={t('Názov')}
          name={'name'}
          rules={[required(t)]}
          placeholder={t('Zadajte názov študijného programu')}
        />

        <FormTextField
          label={t('Skratka')}
          name={'shortcut'}
          rules={[required(t)]}
          placeholder={t('Zadajte skratku študijného programu')}
        />

        <FormSelect
          label={t('Typ študijného programu')}
          name={'study_program_type_id'}
          rules={[required(t)]}
          placeholder={t('Vyberte typ študijného programu')}
          options={studyProgramTypesOptions}
        />

        <FormTextField
          label={t('WS kód')}
          name={'ws_code'}
          placeholder={t('Zadajte WS kód')}
        />

        <FormSelect
          label={t('Garant')}
          name={'guarantee'}
          placeholder={t('Vyberte garanta')}
          options={teachersOptions}
        />

        <FormSwitch
          label={t('Aktívny')}
          name={'active'}
        />
      </CollapseBlock>

      <FormButtonsContainer>
        <FormButton submitOnClick={true} submitKey={'study-programs'}>
          {t('Uložiť')}
        </FormButton>
      </FormButtonsContainer>
    </Form>
  );
};

StudyProgramForm.propTypes = {
  form: PropTypes.object.isRequired,
  studyProgramTypes: PropTypes.array,
  teachers: PropTypes.array,
  onSubmit: PropTypes.func.isRequired,
  initials: PropTypes.object,
  isCreate: PropTypes.bool,
};

export default StudyProgramForm;
